import { Box } from '../../primitives/Box/Box.es.js';
import Popover from '../Popover/Popover.es.js';
import '../Popover/PopoverContext.es.js';
import { List } from '../List/List.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, themeMode, fontSize, fontWeight, color, radius } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';

const Separator = styled(Box).attrs(() => ({ as: "li", role: "presentation", "aria-hidden": true }))`
    display: inline-flex;
    align-items: center;
    pointer-events: none;
    margin: 0 ${spacing("xs")};
    color: ${themeMode({
  dark: color("neutral.400"),
  light: color("neutral.500")
})};
`;
const Placeholder = styled(Box).attrs(() => ({ as: "button" }))`
    display: inline-flex;
    align-items: center;
    outline: none;
    color: ${themeMode({
  dark: color("neutral.400"),
  light: color("neutral.500")
})};
    cursor: pointer;
    &:hover {
        color: inherit;
        text-decoration: underline;
    }
`;
const PopoverContent = styled(Popover.Content)`
    padding: 0;
`;
const PopoverList = styled(List)`
    padding: ${spacing("xs")} 0;
`;
const ListItem = styled(List.Item)`
    & > * {
        color: ${themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
})};
    },
`;
const Item = styled(Box).attrs(() => ({ as: "li" }))`
    display: inline-flex;
    align-items: center;
    font-size: ${({ size }) => size && fontSize(size)};

    overflow: hidden;

    color: ${themeMode({
  dark: color("neutral.400"),
  light: color("neutral.500")
})};

    &:hover,
    &:last-child {
        color: ${themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
})};
    }
`;
const Link = styled("a").attrs(({ isCurrent }) => ({
  "aria-current": isCurrent ? "page" : void 0,
  role: "link"
}))`
    flex: 0 1 auto;
    position: relative;
    text-decoration: none;
    color: inherit;
    font-size: ${({ size }) => size && fontSize(size)};

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        color: inherit;
        cursor: pointer;
        text-decoration: underline;
    }

    &[aria-current='page'] {
        cursor: default;
        font-weight: ${fontWeight("bold")};
        color: ${themeMode({
  dark: color("neutral.50"),
  light: color("neutral.900")
})};
        text-decoration: none;
        pointer-events: none;
    }

    &:not(:first-child) {
        margin-left: ${spacing("xs")};
    }

    &:focus-visible {
        outline: 0;
        box-shadow: none;
    }

    &:after {
        content: '';
        position: absolute;
        top: -3px;
        left: -6px;
        width: calc(100% + 12px);
        height: calc(100% + 6px);
        opacity: 0;
        transition: opacity 200ms ease-in;
        border-width: 2px;
        border-style: solid;
        border-color: ${color("border.base")};
        border-radius: ${radius("lg")};
    }

    &:focus-visible:after {
        opacity: 1;
    }
`;
const Wrapper = styled(Box).attrs(() => ({ as: "ol" }))`
    display: flex;
    margin: 0;
`;
const Breadcrumb = styled(Box).attrs(() => ({ as: "nav" }))`
    width: 100%;
`;

export { Breadcrumb, Item, Link, ListItem, Placeholder, PopoverContent, PopoverList, Separator, Wrapper };
//# sourceMappingURL=styled.es.js.map
